import en from './en';
import th from './th';
import zh from './zh';

export * from './common';

export const translations = { en, th, zh };

const STORAGE_KEY = 'portfolio-language';

// Saved choice first, then the browser language, then English.
export const getInitialLanguage = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
  } catch (error) {
    // Storage can be blocked; fall through to the browser language.
  }
  const browser = (window.navigator.language || '').toLowerCase();
  if (browser.startsWith('th')) return 'th';
  if (browser.startsWith('zh')) return 'zh';
  return 'en';
};

export const saveLanguage = (code) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch (error) {
    // The choice just won't be remembered.
  }
};
